module.exports = __webpack_public_path__ + "static/media/personal-protective-equipment-add.72ef1d5a.svg";